import { Component, OnInit } from '@angular/core';
import { StatuschartService } from './service/statuschart.service';
import { Project } from '@src/app/models/project';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Projectperson } from '@src/app/models/projectperson';
import { PersonOrganization } from '@src/app/models/personorganization';
import { Statuschart } from './model/statuschart';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-statuschart',
  templateUrl: './statuschart.component.html',
  styleUrls: ['./statuschart.component.css']
})
export class StatuschartComponent implements OnInit{
  orgMembers:PersonOrganization[];
  projects:Project[];
  projectperson:Projectperson[];
  statuschart:Statuschart[];
  constructor(
    private scs: StatuschartService,
    private datastore: DatastoreService) { }

  ngOnInit(): void {
    this.statuschart = [];
    this.datastore.orgMembers$.pipe(untilDestroyed(this)).subscribe(data => {
    //this.scs.getOrgMembers().pipe(untilDestroyed(this)).subscribe( data =>{
      this.orgMembers = data;
      this.projects = JSON.parse(SessionHelper.getPortalProjectList());
      this.orgMembers.forEach(memb => {
        this.scs.getPersonProjects(memb.personId).pipe(untilDestroyed(this)).subscribe((data:Projectperson[])=>{
        //Count the number of overdue projects for each member
        var overdue = 0;
        var almost = 0;
        var ontime = 0;
        var total = 0;
        data.forEach(proj => {
          var project = this.projects.find(p => p.projectId == proj.projectId);
          if(project){
            total++;
            if(project.overduedays >= 3){
              overdue++;
            }else if(project.overduedays < 3 && project.overduedays > 0){
              almost++;
            }else{
              ontime++;
            }

          }
      });
      var statuschart = new Statuschart();
      statuschart.personId = memb.personId;
      statuschart.name = memb.membername;
      statuschart.almost = almost;
      statuschart.overdue = overdue;
      statuschart.ontime = ontime;
      this.statuschart.push(statuschart);

    });
    });
    
    


  });

}


}
